"use strict";
exports.__esModule = true;
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var ZONE_COLORS = {
    'DISCOVERY': '#ffcce469',
    'SPECIFY': '#ffffb3F0',
    'NAVIGATE': '#a0c5f899',
    'MANAGE': '#b3ffe4A0'
};
function makeIssueZoneAndColor(ignorance, impact) {
    var issueColor = ZONE_COLORS.MANAGE;
    var issueZone = 'Manage';
    if (ignorance >= 5 && impact >= 5) {
        issueColor = ZONE_COLORS.DISCOVERY;
        issueZone = 'Discovery';
    }
    else if (ignorance >= 5 && impact < 5) {
        issueColor = ZONE_COLORS.SPECIFY;
        issueZone = 'Specify';
    }
    else if (ignorance < 5 && impact >= 5) {
        issueColor = ZONE_COLORS.NAVIGATE;
        issueZone = 'Navigate';
    }
    return { 'issueZone': issueZone, 'issueColor': issueColor };
}
// function formatIssueData(item: any) {
//     const score = item.prevIG * item.prevIM;
//     let issueZoneDetails = makeIssueZoneAndColor(item.prevIG, item.prevIM);
//     return {
//         name: item.name,
//         prevIG: item.prevIG,
//         prevIM: item.prevIM,
//         prevScore: score,
//         newIG: 'newIG' in item ? item.newIG : undefined,
//         newIM: 'newIM' in item ? item.newIM : undefined,
//         newScore: 'newScore' in item ? item.newScore : undefined,
//         cost: 'cost' in item ? item.cost : undefined,
//         totalCost: 'totalCost' in item ? item.totalCost : undefined,
//         duration: 'duration' in item ? item.duration : undefined,
//         expName: 'expName' in item ? item.expName : 'Other',
//         otherExpName: 'otherExpName' in item ? item.otherExpName : undefined,
//         deltaScore: 'deltaScore' in item ? item.deltaScore : undefined,
//         issueZone: issueZoneDetails['issueZone'],
//         done: isFilled(item),
//         includeInSprint: 'includeInSprint' in item ? item.includeInSprint : true,
//         issueColor: issueZoneDetails['issueColor'],
//         issueDescription: 'issueDescription' in item ? item.issueDescription : undefined,
//         needToLearn: 'needToLearn' in item ? item.needToLearn : undefined,
//         goingToLearn: 'goingToLearn' in item ? item.goingToLearn : undefined,
//         toMeasure: 'toMeasure' in item ? item.toMeasure : undefined,
//         successCriteria: 'successCriteria' in item ? item.successCriteria : undefined,
//         issueFactor: 'issueFactor' in item ? item.issueFactor : undefined,
//         inIterationPlan: 'inIterationPlan' in item ? item.inIterationPlan : false,
//         startDate: 'startDate' in item ? new Date(item.startDate) : undefined
//     };
// }
// function isFilled(item) {
//     return item.needToLearn && item.needToLearn !== "" &&
//         item.goingToLearn && item.goingToLearn !== "" &&
//         item.toMeasure && item.toMeasure !== "" &&
//         item.successCriteria && item.successCriteria !== "" &&
//         item.otherExpName && item.otherExpName !== "" &&
//         item.totalCost && item.totalCost !== "" &&
//         item.duration && item.duration !== "";
// }
var ExperimentPriorityComponent = /** @class */ (function () {
    function ExperimentPriorityComponent($scope, $timeout) {
        this.disableEdit = false;
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.dashboardExpPriority = false;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.NONE);
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $scope.$on('command:EXPERIMENT_PRIORITY', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.title = args.actionMenuItem;
            ctrl.dashboardExpPriority = false;
            ctrl.initExpPriority(event, args);
            ctrl.$scope.$apply();
        });
        $scope.$on('command:DASHBOARD_EXPERIMENT_PRIORITY', function (event, args) {
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.dashboardExpPriority = true;
            ctrl.title = args.actionMenuItem;
            ctrl.initExpPriority(event, args);
            ctrl.$scope.$apply();
        });
    }
    ExperimentPriorityComponent.prototype.initExpPriority = function (event, args) {
        var ctrl = this;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        // Use the shared utility method to determine mode if config is available
        if (args.config) {
            var modeConfig = ctrl.utilsService.determineQualitativeMode(args.config, ctrl.node);
            ctrl.isQualitative = modeConfig.isQualitative;
        }
        else {
            // Default to Quantitative if no config is available
            ctrl.isQualitative = false;
        }
        ctrl.issueData = [];
        args.issueData.map(function (issue) {
            var experiment = issue.experimentData[0];
            if (experiment) {
                experiment.status = !('status' in experiment) ? "Unplanned" : experiment.status;
                if (experiment.status == "Backlog" || experiment.status == "In Plan") {
                    var impactToBeUsed = ctrl.isQualitative ? issue['impact'] : issue['calcImpact'];
                    var issueZoneDetails = makeIssueZoneAndColor(issue['ignorance'], impactToBeUsed);
                    issue['issueZone'] = issueZoneDetails['issueZone'];
                    issue['issueColor'] = issueZoneDetails['issueColor'];
                    if (!('inIterationPlan' in issue)) {
                        issue['inIterationPlan'] = false;
                    }
                    ctrl.issueData.push(issue);
                }
            }
        });
        ctrl.generateGraph();
        ctrl.menu = [];
    };
    ExperimentPriorityComponent.prototype.generateGraph = function () {
        var ctrl = this;
        var chartData = ctrl.makeGraphData();
        ctrl.tableData = {
            issueIds: [''].concat(chartData['issueIds']),
            issueNames: [''].concat(chartData['issueNames']),
            inIterationPlan: ['In Learning Plan'].concat(chartData['inIterationPlan']),
            costArray: ['Cost ($k)'].concat(chartData['costArray']),
            readinessArray: ['Surprise Index'].concat(chartData['readinessArray']),
            productivityArray: ['Productivity'].concat(chartData['productivityArray']),
            cumulativeCostArray: ['Cumulative Cost ($k)'].concat(chartData['cumulativeCostArray']),
            cumulativeDeltaArray: ['Cumulative Readiness'].concat(chartData['cumulativeDeltaArray'])
        };
        var series = [];
        chartData.issueZones.forEach(function (zone, idx) {
            series.push({
                x: chartData['cumulativeDeltaArray'][idx],
                y: chartData['cumulativeCostArray'][idx],
                color: chartData['issueColors'][idx]
            });
        });
        Highcharts.chart('chartContainer', {
            chart: {
                type: 'line',
                inverted: true,
                zoomType: 'xy'
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Experiment Frontier'
            },
            yAxis: {
                title: {
                    text: 'Cumulative Cost ($k)'
                }
            },
            xAxis: {
                reversed: false,
                title: {
                    text: 'Cumulative Score'
                },
                min: 0
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    marker: {
                        enabled: true,
                        radius: 6
                    },
                    color: 'lightgrey'
                }
            },
            tooltip: {
                crosshairs: true,
                formatter: function () {
                    return '<b>' + chartData.issueNames[this.point.index] + '</b><br/> ' +
                        '<i>Cumulative Score: </i>' + this.point.options['x'] + '<br/>' +
                        '<i>Cumulative Cost ($): </i>' + this.point.options['y'] + 'k';
                }
            },
            series: [{
                    data: series
                }]
        });
        ctrl.$scope.$apply();
    };
    ExperimentPriorityComponent.prototype.makeGraphData = function () {
        var ctrl = this;
        var arrayToBeSorted = [];
        var totalPrevScore = 0;
        ctrl.issueData.forEach(function (issue) {
            var impactToBeUsed = ctrl.isQualitative ? issue['impact'] : issue['calcImpact'];
            issue['score'] = issue['ignorance'] * impactToBeUsed;
            arrayToBeSorted.push([
                issue['name'],
                issue['score'],
                issue.experimentData[0]['totalCost'],
                (issue['score'] / issue.experimentData[0]['totalCost']),
                issue['issueZone'],
                issue['inIterationPlan'],
                issue.experimentData[0]['totalCost'],
                issue['issueColor'],
                issue['_id']
            ]);
            if ('score' in issue) {
                totalPrevScore += issue['score'];
            }
        });
        var sortedArray = arrayToBeSorted.sort(function (a, b) {
            return b[3] - a[3];
        });
        var cumulativeCost = 0;
        var cumulativeCostArray = [0];
        var cumulativeDelta = totalPrevScore;
        var cumulativeDeltaArray = [totalPrevScore];
        var issueNames = ['Start'];
        var issueZones = ['Start'];
        var issueColors = ['lightgrey'];
        var inIterationPlan = [false];
        var cost = [''];
        var readiness = [''];
        var productivity = [''];
        var issueIds = [''];
        sortedArray.forEach(function (issue) {
            cumulativeCost += issue[2];
            cumulativeCostArray.push(cumulativeCost);
            cumulativeDelta -= issue[1];
            cumulativeDeltaArray.push(cumulativeDelta);
            issueNames.push(issue[0]);
            issueZones.push(issue[4]);
            issueColors.push(issue[7]);
            inIterationPlan.push(issue[5]);
            cost.push(issue[6]);
            readiness.push(issue[1]);
            productivity.push(issue[3].toFixed(2));
            issueIds.push(issue[8]);
        });
        return {
            cumulativeCostArray: cumulativeCostArray,
            cumulativeDeltaArray: cumulativeDeltaArray,
            issueNames: issueNames,
            issueIds: issueIds,
            issueZones: issueZones,
            inIterationPlan: inIterationPlan,
            costArray: cost,
            readinessArray: readiness,
            productivityArray: productivity,
            issueColors: issueColors
        };
    };
    ExperimentPriorityComponent.prototype.changeIterationPlan = function (issueId, isSelected) {
        var ctrl = this;
        ctrl.issueData.forEach(function (issue) {
            if (issue._id == issueId) {
                issue.inIterationPlan = isSelected;
                if (isSelected) {
                    issue.experimentData[0].status = "In Plan";
                    issue.experimentData[0].startDatePotential = ctrl.utilsService.updatedAt();
                }
                else {
                    issue.experimentData[0].status = "Backlog";
                    issue.experimentData[0].startDatePotential = null;
                }
                // ctrl.selectedIndex = idx;
                ctrl.saveIssueAndExperimentData(angular.copy(issue));
            }
        });
    };
    ExperimentPriorityComponent.prototype.saveIssueAndExperimentData = function (issue) {
        var ctrl = this;
        var experimentData = angular.copy(issue.experimentData[0]);
        // let issue = angular.copy(ctrl.issueData);
        delete issue.experimentData;
        delete issue.issueColor;
        delete issue.issueZone;
        ctrl.smartorg.saveInavIssueAndExperiment(ctrl.node._id, issue, experimentData).then(function (res) {
            if (res) {
                // ctrl.issueData[ctrl.selectedIndex] = formatIssueData(ctrl.issueData[ctrl.selectedIndex]);
                // ctrl.showAlert('success', 'Saved!', 'Details saved for issue "' +
                //     ctrl.issueData[ctrl.selectedIndex]['name'] + '"');
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
        // ctrl.smartorg.saveInavIssueDataFromExpMgmt(
        //     ctrl.issueData[ctrl.selectedIndex], ctrl.node['_id']
        // ).then((res) => {
        //     if (res) {
        //         ctrl.issueData[ctrl.selectedIndex] = formatIssueData(ctrl.issueData[ctrl.selectedIndex]);
        //         ctrl.showAlert('success', 'Saved!', 'Details saved for issue "' +
        //             ctrl.issueData[ctrl.selectedIndex]['name'] + '"');
        //         ctrl.$scope.$apply();
        //     } else {
        //         ctrl.showAlert('danger', 'Error!', res.message);
        //     }
        // }).catch((err) => {
        //     ctrl.showAlert('danger', 'Error!', err.message);
        // });
    };
    return ExperimentPriorityComponent;
}());
exports.ExperimentPriorityComponent = ExperimentPriorityComponent;
angular.module('smartorg.r6.acts.experimentPriority', []).component('experimentPriority', {
    template: require('./experiment-priority.component.html'),
    controller: ExperimentPriorityComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.experimentPriority';
//# sourceMappingURL=experiment-priority.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/experiment-priority/experiment-priority.component.js